// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__2yqQ3"};